
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type subtitlesRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function subtitlesRT(): TemplateResult<subtitlesRTRootProps> {
    function repeatCategory1(category, categoryIndex) {
        return _createElement('div', { 'className': 'cm_vehicle-categories_category-wrapper' }, _createElement('a', {
            'className': 'cm_vehicle-categories_category-container cm_vehicle-categories_link',
            'href': category.href
        }, _createElement('div', { 'className': 'cm_vehicle-categories_category-image-container cm_vehicle-categories_link' }, _createElement('img', {
            'className': 'cm_vehicle-categories_category-image',
            'src': category.imageUrl,
            'alt': category.value
        })), _createElement('div', { 'className': 'cm_vehicle-categories_category-title-container cm_vehicle-categories_link' }, _createElement('h5', { 'className': 'cm_vehicle-categories_category-title' }, category.value))));
    }
    function repeatHierarchicalGroups2(hierarchicalGroups, hierarchicalGroupsIndex) {
        return [hierarchicalGroups(function () {
                return _createElement('div', { 'className': 'cm_vehicle-categories_category-wrapper' + (this.isSelected ? ' selected' : '') }, _createElement('a', {
                    'className': 'cm_vehicle-categories_category-container cm_vehicle-categories_link',
                    'href': this.href
                }, _createElement('div', { 'className': 'cm_vehicle-categories_category-image-container cm_vehicle-categories_link' }, _createElement('img', {
                    'className': 'cm_vehicle-categories_category-image',
                    'src': this.getImageOrDefault(this.imageUrl),
                    'alt': this.value
                })), _createElement('div', { 'className': 'cm_vehicle-categories_category-title-container cm_vehicle-categories_link' }, _createElement('h5', { 'className': 'cm_vehicle-categories_category-title' }, this.value))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_vehicle-categories cm_vehicle-categories__subcategories cm_vehicle-categories__flat' }, !!window.Convermax.corvetteMegaMenu ? _createElement.apply(this, [
        'div',
        {
            'className': 'cm_vehicle-categories_category-wrapper-repeater',
            'data-cm-scroll-container': this.view === 'carousel',
            'key': '104'
        },
        _map(window.Convermax.corvetteMegaMenu, repeatCategory1.bind(this))
    ]) : null, !window.Convermax.corvetteMegaMenu ? [_createElement.apply(this, [
            'div',
            {
                'className': 'cm_vehicle-categories_category-wrapper-repeater  cmRepeater_hierarchicalGroups',
                'data-cm-scroll-container': this.view === 'carousel',
                'key': '9521'
            },
            _map(this.hierarchicalGroups, repeatHierarchicalGroups2.bind(this))
        ])] : null, (this.hierarchicalGroups?.length || window.Convermax.corvetteMegaMenu) && this.view === 'carousel' ? [
        _createElement('button', {
            'type': 'button',
            'className': 'cm_vehicle-categories_category-scroll-button cm_vehicle-categories_category-scroll-button_left',
            'onClick': this.scrollLeft,
            'disabled': this.isLeftBorder,
            'data-cm-scroll-left': true,
            'key': '22741'
        }),
        _createElement('button', {
            'type': 'button',
            'className': 'cm_vehicle-categories_category-scroll-button cm_vehicle-categories_category-scroll-button_right',
            'onClick': this.scrollRight,
            'disabled': this.isRightBorder,
            'data-cm-scroll-right': true,
            'key': '22743'
        })
    ] : null);
}
        export const componentNames = []